import React from 'react';
import { Film, Mail, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#040c14] border-t border-[#152840] py-12 px-4 relative overflow-hidden">
      {/* Abstract background elements */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="abstract-blob" style={{ top: '20%', left: '10%', width: '300px', height: '300px', background: 'radial-gradient(circle, rgba(255, 101, 0, 0.3), transparent)' }}></div>
        <div className="abstract-blob" style={{ bottom: '10%', right: '15%', width: '250px', height: '250px', background: 'radial-gradient(circle, rgba(255, 140, 50, 0.2), transparent)' }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 overflow-hidden flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_foxpress-creative/artifacts/dx75uml5_Augmented%20Cinematics.png" 
                  alt="Augmented Cinematics Logo"
                  className="h-12 w-auto"
                  style={{ objectFit: 'cover', objectPosition: 'left center', marginLeft: '-10px' }}
                />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Augmented Cinematics</h3>
                <p className="text-xs text-[#aaa]">Harry Mann, Creative Director</p>
              </div>
            </div>
            <p className="text-[#aaa] text-sm leading-relaxed">
              Transforming books into screen-ready IP through cinematic storytelling.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#proof" className="text-[#aaa] hover:text-white transition-colors duration-300 text-sm">
                  Proof Reel
                </a>
              </li>
              <li>
                <a href="#framework" className="text-[#aaa] hover:text-white transition-colors duration-300 text-sm">
                  Framework
                </a>
              </li>
              <li>
                <a href="#library" className="text-[#aaa] hover:text-white transition-colors duration-300 text-sm">
                  Proof Library
                </a>
              </li>
              <li>
                <a href="#contact" className="text-[#aaa] hover:text-white transition-colors duration-300 text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Connect</h4>
            <div className="flex gap-4 mb-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-[#0a1525] hover:bg-[#FF6500] rounded-full flex items-center justify-center transition-all duration-300 group"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-[#aaa] group-hover:text-black" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#0a1525] hover:bg-[#FF6500] rounded-full flex items-center justify-center transition-all duration-300 group"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5 text-[#aaa] group-hover:text-black" />
              </a>
              <a 
                href="mailto:harrymann.intl@gmail.com" 
                className="w-10 h-10 bg-[#0a1525] hover:bg-[#FF6500] rounded-full flex items-center justify-center transition-all duration-300 group"
                aria-label="Email"
              >
                <Mail className="w-5 h-5 text-[#aaa] group-hover:text-black" />
              </a>
            </div>
            <p className="text-[#aaa] text-sm">
              <a 
                href="mailto:harrymann.intl@gmail.com"
                className="hover:text-white transition-colors duration-300"
              >
                harrymann.intl@gmail.com
              </a>
            </p>
          </div>
        </div>
        
        <div className="border-t border-[#152840] pt-8 flex flex-col items-center gap-4">
          <div className="flex items-center gap-3">
            <span className="text-[#717171] text-xs">A white-label production partner with</span>
            <a 
              href="https://foxpressstudios.us/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity duration-300"
            >
              <img 
                src="https://foxpressstudios.us/wp-content/uploads/2025/05/nav-bar-logo-white.png" 
                alt="FoxPress Studios"
                className="h-6"
              />
            </a>
          </div>
          <p className="text-[#717171] text-sm">
            © {new Date().getFullYear()} Augmented Cinematics. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;